'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, parentNode, alignToStart) {
  if (parentNode && parentNode.contains(node)) {
    var clientHeight = parentNode.clientHeight,
        clientWidth = parentNode.clientWidth,
        scrollTop = parentNode.scrollTop,
        scrollLeft = parentNode.scrollLeft;
    var offsetHeight = node.offsetHeight,
        offsetWidth = node.offsetWidth,
        offsetTop = node.offsetTop,
        offsetLeft = node.offsetLeft;

    var parentPosition = window.getComputedStyle(parentNode).position;
    var parentOffsetTop = parentNode.offsetTop;
    var parentOffsetLeft = parentNode.offsetLeft;

    if (parentPosition !== 'static') {
      parentOffsetTop = parentOffsetLeft = 0;
    }

    if (offsetTop < scrollTop) {
      parentNode.scrollTop = offsetTop;
    } else {
      var offsetBottom = offsetTop + offsetHeight;
      var scrollBottom = scrollTop + clientHeight;
      if (offsetBottom > scrollBottom) {
        parentNode.scrollTop = alignToStart ? offsetTop - parentOffsetTop : offsetBottom - clientHeight - parentOffsetTop;
      }
    }

    if (offsetLeft < scrollLeft) {
      parentNode.scrollLeft = offsetLeft;
    } else {
      var offsetRight = offsetLeft + offsetWidth;
      var scrollRight = scrollLeft + clientWidth;
      if (offsetRight > scrollRight) {
        parentNode.scrollLeft = alignToStart ? offsetLeft - parentOffsetLeft : offsetRight - clientWidth - parentOffsetLeft;
      }
    }
  }
};